import React, { useState, useEffect } from 'react';
import useStyles from '../../../styles';
import { IconButton, Modal, Backdrop, Fade, Box } from '@material-ui/core';
import Table, { columnType } from '../../../components/ClearingTable/Table';
import { readExerciseDeclaration } from '../../../services/ExerciseDeclarationService';
import { Close as CloseIcon } from '@material-ui/icons';
import {
  CustomBodyRenderAlign,
  CustomBodyRenderQty,
} from '../../../components/Table/CustomBodyRender';

export default function ExerciseDeclarationDetails({
  onClose: handleClose,
  open: isOpen,
  value,
}) {
  const classes = useStyles();

  const [rows, setRows] = useState([]);

  const columns = [
    {
      name: 'symbol',
      label: 'Symbol',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
    {
      name: 'eed',
      label: 'EED',
      type: columnType.quantity,
      options: {
        customBodyRender: CustomBodyRenderQty,
      },
    },
    {
      name: 'dned',
      label: 'DNED',
      type: columnType.quantity,
      options: {
        customBodyRender: CustomBodyRenderQty,
      },
    },
    {
      name: 'contraryId',
      label: 'ID',
      options: {
        customBodyRender: CustomBodyRenderAlign,
      },
    },
  ];

  const options = {
    selectableRows: 'none',
  };

  useEffect(
    () => {
      async function init() {
        const data = await readExerciseDeclaration(value);
        setRows(data.declarationDetailsList);
      }

      if (isOpen) {
        init();
      }
    }, // eslint-disable-next-line
    [isOpen]
  );

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modalBackdrop}
      open={isOpen}
      onClose={() => {
        handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={isOpen}>
        <div className={classes.tableModalFull}>
          <Box component="div" mt={2}>
            <Table
              title="EXERCISE DECLARATION DETAILS"
              data={rows}
              columns={columns}
              options={options}
            />
          </Box>

          <div className={classes.modalFooter}>
            <div className={classes.grdCellNone} style={{ marginRight: 10 }}>
              <div className={classes.modalCloseIcon} style={{ marginRight: 10 }}>
                <IconButton
                  aria-label="close"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  <CloseIcon style={{ color: '#f1f1f1' }} />
                </IconButton>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
